(function (browser, factory) {
  'use strict';
  var api = factory();
  if (browser) browser.TeaLogic = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  // What the chosen teas cost bought one at a time. The bundle amount itself is never worked out
  // here: TeaCheckout reads it from the store's bundle variant and its plan allocation.
  function price(products) {
    var seen = new Set();
    var subtotal = (Array.isArray(products) ? products : []).reduce(function (total, p) {
      if (!p || !Number.isSafeInteger(p.priceCents) || p.priceCents < 0) throw new TypeError('Product prices must be non-negative integer cents.');
      if (seen.has(p.id)) return total;
      seen.add(p.id);
      var next = total + p.priceCents;
      if (!Number.isSafeInteger(next)) throw new RangeError('Price exceeds safe integer cents.');
      return next;
    }, 0);
    return { subtotalCents: subtotal, totalCents: subtotal, savingCents: 0, bundleApplied: false };
  }
  return Object.freeze({ price: price });
});
